import React from 'react';
import _ from 'lodash';

import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router';

import Button from 'components/Button';

import SearchFilter from 'components/Filters/SearchFilter';
import ButtonSwitch from 'components/ButtonSwitch';
import {selectViewOptions, MODALS, VIEW_CHOICES} from 'ducks/allocations';

import {requiresPermission, PERMISSIONS} from 'ducks/auth';
import {openModal} from 'ducks/modals';

import plusIcon from './assets/plus-icon.svg';

import './styles.css';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
  requiresPermission: any;
  openModal: any;
  selectedRoomsIds: string[];
  redirectToRoomAllocations: any;
}

class SubNavigation extends React.Component<
  SubNavigationProps & RouteComponentProps<{locationRef: string}>
> {
  openAssignPurposeModal = () => {
    const {locationRef} = this.props.match.params;

    this.props.requiresPermission(
      {
        locationRef,
        permission: PERMISSIONS.CREATE_ROOM_PURPOSES
      },
      () => this.props.openModal(MODALS.ASSIGN_ROOM_PURPOSE, {locationRef})
    );
  };
  render() {
    const {selectedRoomsIds} = this.props;

    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered colab-row-space-between">
        <div className="SubNavigation__assign-button">
          <div className="image">
            <img src={plusIcon} className="plusIcon" />
          </div>
          <Button
            blue
            className="assignPurposeButton"
            onClick={this.openAssignPurposeModal}
            disabled={_.isEmpty(selectedRoomsIds)}>
            Assign Room Purpose
          </Button>
        </div>
        <ButtonSwitch
          className="AllocationsViewSwitch"
          options={selectViewOptions}
          initialValue={VIEW_CHOICES.PURPOSES}
          onChange={() => this.props.redirectToRoomAllocations}
        />
        <div className="filtersSection colab-elements-row">
          <SearchFilter
            value={this.props.filters.search}
            onChange={(search: string) =>
              this.props.setFilter('search', search)
            }
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  requiresPermission,
  openModal
};

export default withRouter(
  connect(null, mapDispatchToProps)(SubNavigation)
) as React.ComponentType<SubNavigationProps>;
